import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schema = z.object({
    Name: z.string().min(1, "Name is required"),
    Description: z.string().optional(),
    DefaultUnitType: z.string().optional(),
    MeasurementTypes: z.any().optional(),
    Tags: z.record(z.string()).optional(),
    IsActive: z.boolean().optional(),
});

const newProductCategoryResolver = zodResolver(schema);

export default newProductCategoryResolver;
